import savePrioritizeSettings from '../utils/savePrioritizeSettings';
import { mutatorAction } from 'satcheljs';
import type { MailboxInfo } from 'owa-client-types';

const onUpdatePrioritizeSettingsMutator: (mailboxInfo: MailboxInfo, response: any) => void =
    mutatorAction('onUpdatePrioritizeSettings', (mailboxInfo: MailboxInfo, response: any): void => {
        savePrioritizeSettings(mailboxInfo, response);
    });

export default onUpdatePrioritizeSettingsMutator;
